import { FC } from 'react';
import { IconProps } from '../../types';

export const Silver3: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_58456)"
      />
      <path
        d="M6.85191 3.888V5.016C6.53991 4.824 6.23991 4.644 5.86791 4.644C5.71191 4.644 5.59191 4.68 5.53191 4.704C5.08791 4.86 4.87191 5.304 4.87191 5.748C4.88391 6.156 5.05191 6.468 5.30391 6.768C5.60391 7.14 5.93991 7.476 6.26391 7.812C6.85191 8.436 7.19991 8.868 7.19991 9.756C7.19991 9.948 7.18791 10.644 6.83991 11.208C6.68391 11.448 6.49191 11.64 6.26391 11.784C5.83191 12.06 5.42391 12.072 5.24391 12.072C4.59591 12.072 4.16391 11.844 3.93591 11.736V10.572C4.04391 10.632 4.52391 10.956 5.05191 10.956C5.31591 10.956 5.50791 10.872 5.59191 10.812C5.74791 10.704 6.03591 10.38 6.03591 9.852C6.03591 9.144 5.62791 8.844 4.78791 7.956C4.17591 7.296 3.69591 6.768 3.69591 5.808C3.69591 5.592 3.71991 5.004 4.04391 4.476C4.23591 4.176 4.71591 3.54 5.68791 3.54C6.27591 3.54 6.65991 3.78 6.85191 3.888ZM9.084 8.124V7.128C9.456 7.164 9.744 7.176 10.02 6.912C10.38 6.588 10.368 6.168 10.368 6.012C10.368 5.868 10.32 5.28 10.296 5.136C10.212 4.656 9.984 4.536 9.768 4.536C9.564 4.536 9.396 4.656 9.348 4.692C9.048 4.908 9.072 5.244 9.06 5.916H7.992C7.98 5.7 7.98 5.496 7.992 5.292C8.004 5.124 8.028 4.488 8.412 4.044C8.808 3.576 9.504 3.576 9.696 3.576C10.476 3.576 10.8 3.792 11.04 4.068C11.484 4.584 11.472 5.16 11.472 5.796C11.46 7.032 11.184 7.296 10.692 7.728C10.992 7.836 11.1 7.908 11.196 8.016C11.424 8.244 11.616 8.748 11.616 9.528C11.616 9.684 11.604 9.84 11.592 10.008C11.544 10.776 11.4 11.124 11.172 11.436C10.776 11.976 10.296 12.096 9.66 12.096C9.516 12.096 8.82 12.12 8.4 11.796C7.884 11.376 7.848 10.512 7.824 9.9H8.928C8.904 10.344 8.916 10.488 9.012 10.692C9.108 10.92 9.336 11.124 9.624 11.124C9.756 11.124 9.888 11.076 10.008 11.004C10.404 10.74 10.38 10.284 10.392 9.84C10.404 9.684 10.416 9.528 10.416 9.372C10.416 9.252 10.428 8.784 10.152 8.424C10.092 8.352 9.984 8.256 9.912 8.22C9.78 8.16 9.564 8.16 9.408 8.148C9.3 8.148 9.192 8.136 9.084 8.124Z"
        fill="#F8F8F8"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6141_58456"
          x1="7"
          y1="18"
          x2="7"
          y2="-3.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#868686" />
          <stop offset="0.239" stopColor="#646464" />
          <stop offset="0.464" stopColor="#C6C6C6" />
          <stop offset="1" stopColor="#7E7E7E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
